import React from 'react'
import {v4 as uuid} from 'uuid'
/**
 * A method to store and return a login challenge
 * This is used for login challenges for the email verification flow
 * @returns {codeChallenge, codeChallengeMethod}
 */
export function useLoginAttemptChallenge() {
    const codeChallengeMethod = 'plain' as const

    React.useEffect(() => {
        if (localStorage.getItem('loginChallenge')) {
            return
        }
        localStorage.setItem('loginChallenge', `pleo-login-code-challenge-${uuid()}`)
    }, [])

    return {codeChallenge: localStorage.getItem('loginChallenge'), codeChallengeMethod}
}
